import styled from 'styled-components';
import StateChip from './StateChip';

const RowHeader = ({ columns, row }) => {
    const template = `repeat(${columns.length}, minmax(100px, 1fr))`;

    return (
        <Wrapper>
            <Header $template={template}>
                {columns.map((col) => (
                    <p key={col.accessor} className="th">
                        {col.label}
                    </p>
                ))}
            </Header>

            <Body $template={template}>
                {columns.map((col) => {
                    const raw = row[col.accessor];
                    const value = col.transform ? col.transform(raw, row) : raw;
                    const isState = col.accessor === 'state';
                    return (
                        <p
                            key={`rowHeader-${col.accessor}`}
                            data-label={col.label}
                            className={isState ? 'no-shrink' : 'truncate'}
                            title={
                                typeof value === 'string' ? value : undefined
                            }
                        >
                            {isState ? (
                                <StateChip value={value} />
                            ) : (
                                (value ?? '-')
                            )}
                        </p>
                    );
                })}
            </Body>
        </Wrapper>
    );
};

export default RowHeader;

const BREAK = '768px';

const Wrapper = styled.div`
    width: calc(100% - 1rem);
    box-sizing: border-box;
    padding: 0 0.5rem;
`;

const sharedGrid = `
  display: grid;
  grid-auto-rows: minmax(30px, auto);
  gap: .5rem;
  width: 100%;
  box-sizing: border-box;
`;

const Header = styled.div`
    ${sharedGrid}
    grid-template-columns: ${(p) => p.$template};
    background-color: #d9d9d9;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    padding: 0.5rem;

    .th {
        font-size: 0.75rem;
        font-weight: 700;
        text-transform: uppercase;
        margin: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        min-width: 0;
    }

    @media (max-width: ${BREAK}) {
        display: none;
    }
`;

const Body = styled.div`
    ${sharedGrid}
    grid-template-columns: ${(p) => p.$template};
    background-color: #f9f9f9;
    padding: 0.5rem;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    align-items: center;

    p {
        margin: 0;
        font-size: 0.85rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        min-width: 0;
    }

    .no-shrink {
        white-space: normal;
        overflow: visible;
    }

    @media (max-width: ${BREAK}) {
        grid-template-columns: 1fr;
        row-gap: 0.25rem;

        p {
            display: grid;
            grid-template-columns: 40% 60%;
            align-items: center;
            gap: 0.5rem;
            padding: 0.35rem 0.25rem;
            background: #fff;
            border-radius: 6px;
            white-space: normal;
            overflow: visible;
            text-overflow: clip;
        }
        p::before {
            content: attr(data-label);
            font-weight: 600;
            color: #6b7280;
            text-transform: uppercase;
            font-size: 0.72rem;
        }
    }
`;
